<template>
  <div>
    <v-btn text color="primary" @click="add">
      <v-icon>add</v-icon>
      New
    </v-btn>
    <v-dialog
      v-model="dialog"
      width="800"
      scrollable
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">
          New Registration
        </v-card-title>

        <v-card-text>
          <v-form>
            <v-card outlined tile class="mt-5">
              <v-card-title>
                Business details
              </v-card-title>
              <v-card-text>
                <abr-search-field
                  v-model="abn"
                  :loading="$apollo.queries.business.loading"
                />
                <v-text-field
                  disabled
                  label="Entity name"
                  v-model="business.entityName"
                />
                <v-text-field
                  label="Member name"
                  v-model="memberName"
                />
                <v-switch
                  v-model="registerBusinessName"
                  :disabled="!business.businessNames.length"
                  label="Use a registered business name"
                />
                <business-name-list
                  v-show="registerBusinessName"
                  v-model="businessName"
                  :business-names="business.businessNames"
                />
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="save"
          >
            Save
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { RegistrationStatus } from '@mymsa/common'

import AbrSearchField from './AbrSearchField.vue'
import BusinessNameList from './BusinessNameList.vue'
import { validateAbn } from '../utilities'
export default {
  name: 'AdminRegistrationDialog',

  components: {
    AbrSearchField,
    BusinessNameList
  },

  data: () => ({
    dialog: false,
    abn: null,
    businessName: -1,
    memberName: null,
    business: {
      businessNames: []
    },
    registerBusinessName: false
  }),

  computed: {
    selectedBusinessName () {
      return this.businessName > -1
        ? this.business.businessNames[this.businessName]
        : null
    }
  },

  watch: {
    registerBusinessName (newVal) {
      if (!newVal) this.businessName = -1
    }
  },

  methods: {
    add () {
      this.abn = null
      this.businessName = -1
      this.memberName = null
      this.registerBusinessName = false
      this.dialog = true
    },

    async save () {
      try {
        const res = await this.$apollo.mutate({
          mutation: gql`mutation ($record: CreateOneRegistrationInput!) {
            registrationCreateOne(record: $record) {
              recordId
            }
          }`,
          variables: {
            record: {
              abn: this.abn,
              entityName: this.business.entityName,
              businessName: this.selectedBusinessName?.businessName,
              businessSearchId: this.selectedBusinessName?.searchId,
              memberName: this.memberName,
              status: RegistrationStatus.SUBMITTED
            }
          }
        })
        const { recordId } = res.data.registrationCreateOne
        this.$emit('info', 'Registration created')
        this.$router.push({ name: 'AdminRegistration', params: { id: recordId } })
      } catch (e) {
        this.$emit('error', e)
      }
    }
  },

  apollo: {
    business: {
      query: gql`query SearchAbn($abn: String!) {
        business: businessByAbn(abn: $abn) {
          businessNames {
            businessName
            searchIdType
            searchId
          }
          entityName
        }
      }`,
      variables () {
        return {
          abn: this.abn
        }
      },
      skip () {
        return !validateAbn(this.abn)
      },
      error (e) { this.$emit('error', e) },
      result ({ data }) {
        if (!data) return
        this.registerBusinessName = data.business.businessNames.length > 0
      }
    }
  }
}
</script>
